import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useLocationCheckpointTourRun.ts
function useLocationCheckpointTourRun(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationCheckpointTourRunDetail.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationCheckpointTourRun };

//# sourceMappingURL=useLocationCheckpointTourRun.js.map